import type { Component, JSX } from "solid-js";
import { Card, CardContent, CardHeader, CardTitle } from "@fleet/ui";
import { useNavigate } from "@tanstack/solid-router";

interface SettingsLinkCardProps {
  title: string;
  to: string;
  icon: Component<{ class?: string }>;
  indicator: JSX.Element;
  label: string;
}

export function SettingsLinkCard(props: SettingsLinkCardProps) {
  const navigate = useNavigate();
  return (
    <Card class="hover:border-primary/30 transition-colors select-none">
      <button
        type="button"
        onClick={() => void navigate({ to: props.to })}
        class="w-full text-left cursor-pointer rounded-xl transition-transform duration-150 ease-swift will-change-transform active:scale-[0.985] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
      >
        <CardHeader class="flex flex-row items-center justify-between space-y-0 pb-2">
          <div class="flex items-center gap-2">
            <props.icon class="h-4 w-4 text-primary" />
            <CardTitle class="text-sm font-medium">{props.title}</CardTitle>
          </div>
          <span class="text-muted-foreground text-xs">→</span>
        </CardHeader>
        <CardContent>
          <div class="flex items-center gap-3">
            <span class="text-2xl shrink-0">{props.indicator}</span>
            <p class="text-sm font-semibold">{props.label}</p>
          </div>
        </CardContent>
      </button>
    </Card>
  );
}
